export const TERPILIH = 'Terpilih'
export const TIDAK_TERPILIH = 'Tidak Terpilih'
export const CHECKER = 'CHECKER'
export const RECOMMENDATION = 'RECOMMENDATION'
export const APPROVER = 'APPROVER'
export const PROCUREMENT_APPROVED = 'PROCUREMENT_APPROVED'
export const PROCUREMENT_REJECTED = 'PROCUREMENT_REJECTED'
export const CHANGE = 'CHANGE'
export const EDIT = 'EDIT'
export const EXCHANGE_RATE_CURRENCY = 'idr'